import { render } from "./VideoChat.vue?vue&type=template&id=6f6dc0d2"
import script from "./VideoChat.vue?vue&type=script&lang=js"
export * from "./VideoChat.vue?vue&type=script&lang=js"

import "./VideoChat.vue?vue&type=style&index=0&id=6f6dc0d2&lang=less"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__